import { useEffect, useState } from 'react';
import { api } from './utils/api';
import "./styles/orderhistory.css"
import { Link } from 'react-router-dom';

function OrderList({list}) {
  return(
    <Link className='orderhis__list' to={`/profile/orderdetails?id=${list.id}`}>
      <div className='orderhis__list__header'>
        <h5>訂單編碼: {list.number}</h5>
        <h6>訂單時間: {list.time}</h6>
      </div>

      <div className='orderhis__list__items'>
        <div className='orderhis__list__item'>
          <img src={list.details[0].main_image} className="item__main-image" alt="product" />
          <div className='item__info'>
            <div className="item__info__title">{list.details[0].title}</div>
            <div className="item__info__id">{list.details[0].id}</div>
            <div className="item__info__colorcode" style={{backgroundColor: `#${list.details[0].color.code}`}}></div>
            <div className="item__info__colorname">{list.details[0].color.name}</div>
            <div className="item__info__size">{list.details[0].size}</div>
            <div className="item__info__pricewrap">
              <div className="item__info__qty">x {list.details[0].qty}</div>
              <div className="item__info__price">TWD.{list.details[0].price}</div>
            </div>
          </div>
        </div>
      </div>

      <div className='orderhis__list__footer'>
        <h5>訂單金額: TWD.{list.total}</h5>
        {
          list.rated ? <button className='rated__true'>已評價</button>
          : <button className='rated__false'>未評價</button>
        }
      </div>
    </Link>
  )
}

export default function OrderHistory() {
  const [orderLists, setOrderLists] = useState([])
  useEffect(() => {
    api.getOrderList(localStorage.getItem("aws_JWT"), "").then((res) => {
      setOrderLists(res.data)
    })
  },[])
  return (
    <div className='orderhis__lists'>
      {orderLists.map((list) => <OrderList list={list} key={list.id}/>)}
    </div>
  );
}
